/**
 * perf-lazy-init.js
 *
 * Helper utilities for safe, low-risk performance tuning.
 * - onIdle(fn): run a function when the browser is idle (or after a delay).
 * - onVisible(selector, fn, options): run when an element becomes visible.
 *
 * This file does not modify existing theme behaviour by itself.
 * It only exposes helpers under window.__perfLazy.
 */
(function () {
  if (window.__perfLazy) {
    return;
  }

  function onIdle(fn) {
    if (typeof fn !== 'function') return;

    if ('requestIdleCallback' in window) {
      requestIdleCallback(fn);
    } else {
      setTimeout(fn, 1500);
    }
  }

  function onVisible(selector, fn, options) {
    if (!selector || typeof fn !== 'function') return;

    var el = document.querySelector(selector);
    if (!el) return;

    if (!('IntersectionObserver' in window)) {
      // Fallback: run immediately after a small delay
      setTimeout(function () {
        fn(el);
      }, 1000);
      return;
    }

    var obs = new IntersectionObserver(function (entries, observer) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          fn(el);
          observer.disconnect();
        }
      });
    }, options || { threshold: 0.2 });

    obs.observe(el);
  }

  window.__perfLazy = {
    onIdle: onIdle,
    onVisible: onVisible
  };

  /**
   * AOS (Animate On Scroll) lazy initialisation
   *
   * Many sections on the site use data-aos attributes. Initialising AOS
   * can be relatively heavy, so we move it to an idle callback.
   * This keeps the initial render and TBT lighter, while preserving
   * all scroll animations.
   */
  onIdle(function () {
    if (window.AOS && typeof AOS.init === 'function') {
      try {
        AOS.init({
          duration: 800,
          once: true
        });
      } catch (e) {
        // Fail silently – we don't want AOS issues to affect page load
      }
    }
  });
})();